import PAText, { FONT_SIZE } from "component/design-system/typography/PAText/PAText";

const ModalTitle = (props: any) => {
  const { className, style = {}, children } = props;
  return (
    <PAText component="div" fontSize={FONT_SIZE[2]} className={`modal-title align-items-center flex-grow-1 ${className}`} style={style}>{children}</PAText>
  );
};

export default ModalTitle;
